import { createPaginatedData } from "./pagination_data_creator";

/**
 * ### *Filters the json data and returns paginated data compatible to use in timeline charts*
 * @param {string} chart_key the view which the chart belongs to
 * @param {Object[]} formatted_json_data the json data in key-value pair format
 * @param {Object} filter_by the filter key values
 */
export default function filter_chart(chart_key, formatted_json_data, filter_by, color_by) {
  console.log({ formatted_json_data, filter_by });
  const filtered_data = [];
  formatted_json_data.forEach((data) => {
    let isValid = true;
    // console.log({ data });
    // let i = 1;
    Object.entries(filter_by).forEach(([key, value], index) => {
      // console.log({ i });
      // console.log(data[key]);
      if (value?.length > 0) {
        console.log(`considering ${key} for filtering - value ${value} - dataKey ${data[key]}`);
        // const x = value.includes(data[key]);
        // console.log({ x });
        if (!value.includes(data[key])) isValid = false;
        else {
          // console.log({ key, value, data });
        }
      }
    });
    if (isValid) {
      console.log("pushing data");
      data.start_time = new Date(data.start_time);
      data.end_time = new Date(data.end_time);
      console.log(data);
      filtered_data.push(data);
    }
  });
  console.log({ filtered_data });
  const paginated_data = createPaginatedData(chart_key, filtered_data, color_by);
  console.log({ paginated_data });
  return paginated_data;
}